import { create } from "zustand";

const useToastStore = create((set) => ({
  open: false,
  message: "",
  severity: "info", // "success" | "error" | "warning" | "info"
  showToast: (message, severity = "info") => {
    set({ open: true, message, severity });
  },
  hideToast: () => {
    set({ open: false });
  },
}));

export default useToastStore;
